import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE__API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;
